import { Page } from '@/core/architecture'

import { TicketShareConfirmTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * TicketShareConfirm Page
 * Implemented as a practical sample.
 */
export const TicketShareConfirm: Page = () => {
  const { state, actions } = useViewModel()

  return <TicketShareConfirmTemplate state={state} {...actions} />
}
